import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
  selector: 'app-file-upload-progress',
  templateUrl: './file-upload-progress.component.html',
  styleUrls: ['./file-upload-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class FileUploadProgressComponent {

  @Input() file: {
    progress: number;
  };
}
